import axios from 'axios';
import Vue from 'vue'

export default {

    findCampaign (page, pageSize, start, end, customersFilter, countryId , cityId ) {
        return axios.get('/api/campaign/list', { params: {page: page, pageSize: pageSize, start:start, end:end, customersFilter:customersFilter, countryId:countryId, cityId:cityId  } })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    deleteCampaign (page, pageSize, start, end, customersFilter, countryId , cityId , campaignId  ) {
        return axios.get('/api/campaign/delete', { params: {page: page, pageSize: pageSize, start:start, end:end, customersFilter:customersFilter, countryId:countryId, cityId:cityId ,campaignId:campaignId } })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },


    findCampaignByCurrentCustomer (page, pageSize ) {
        return axios.get('/api/campaign/list/customer', { params: {page: page, pageSize: pageSize}})
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getSector () {
        return axios.get('/api/campaign/sector/list')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getBagSize () {
        return axios.get('/api/campaign/bag/size/list')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    repeatExperience (campaignId) {
        return axios.get('/api/campaign/repeatExperience',  { params: {campaignId:campaignId}})
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
    
    getDataFields () {
        return axios.get('/api/campaign/fields/list')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    saveSettingsCampain (settingsCampaign) {
        return axios.post('/api/campaign/save/settings' , settingsCampaign )
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    saveMenuOrderSettingsCampain (settingsMenuOrderCampaign) {
        return axios.post('/api/campaign/save/menu-order/settings' , settingsMenuOrderCampaign )
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getPlanningDeliveryBagsList (page, pageSize, campaignId, status ) {
        return axios.get('/api/campaign/list/planning/delivery-bag', { params: {page: page, pageSize: pageSize, campaignId:campaignId , status:status}})
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
    getEventsDeliveryBagByPosBarCode (deliveryBagPlanningId ) {
        return axios.get('/api/campaign/details/delivery-bag', { params: {deliveryBagPlanningId: deliveryBagPlanningId}})
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
    planningDeliveryBag (campaignId) {
        return axios.get('/api/campaign/planning/delivery-bag' , {params : {campaignId:campaignId}} )
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    savePlanningDelivery (planningDeliveryRequest) {
        return axios.post('/api/campaign/save/planning/delivery-bag' , planningDeliveryRequest )
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    saveZoneCampain (zoneCampain) {
        return axios.post('/api/campaign/save/zone' , zoneCampain )
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    findDetailsCampainById (campaignId) {
        return axios.get('/api/campaign/details' , {params : {campaignId:campaignId}} )
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },


    saveQrSettingsCampaign(formData, campaignQrSetting) {

        formData.append('campaignQrSettingsRequestDTO', new Blob([JSON.stringify(campaignQrSetting)], {
            type: 'application/json'
        }));
    
        return axios.post('/api/campaign/save/qr/settings', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {
            Vue.prototype.$snotify.error(error);
        });
    },

    deleteMedia (campaignId, mediaName) {
        return axios.get(`/api/campaign/delete/medias/${campaignId}/${mediaName}`)
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    saveMedia(formData) {

        return axios.post('/api/campaign/upload/medias', formData , {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {
            Vue.prototype.$snotify.error(error);
        });
    },

    findCarrierDeliveryModes () {
        return axios.get('/api/campaign/carrier-modes')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    downloadFParcelAwb(deliveryBagPlanningId ){
        axios({
            url:'/api/campaign/carrier/awb/' + deliveryBagPlanningId ,
            method: 'GET',
            responseType: 'blob', // important
            }).then((response) => {

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Bordereau-Livraison.pdf');
            document.body.appendChild(link);
            link.click();
            });
    },

    addManualPartner (idList, campaignId) {
        return axios.get('/api/campaign/add/manual/partner', {params : {campaignId:campaignId, idList:idList}})
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    findMediaByCode(code) {
        return axios.get('/api/image/images-campaign/get/' + code, {responseType: 'arraybuffer'}).then(response => {
            if (response && response.data) {
                const base64Image = this.arrayBufferToBase64(response.data);
                return `data:image/png;base64,${base64Image}`;
            }
        })
        .catch(error => {
            Vue.prototype.$snotify.error(error);
        });
    },
    
    arrayBufferToBase64(buffer) {
        let binary = '';
        const bytes = new Uint8Array(buffer);
        for (let i = 0; i < bytes.byteLength; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
    },

    saveMenuSecretCode (menuSecretCod) {
        return axios.post('/api/campaign/save/secret-code' , menuSecretCod )
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})

    },

    
}

